"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("../slicedToArray-a539bf82.js"),
  t = require("../toConsumableArray-c6b4eb92.js"),
  a = require("react"),
  n = require("classnames"),
  i = require("styled-components"),
  r = require("prop-types"),
  l = require("../grid-965d799c.js"),
  o = require("../dynamicCallout-8fa63d9d.js"),
  d = require("../typography-fb2881fe.js"),
  u = require("../styles-857c7872.js"),
  c = require("../taggedTemplateLiteral-97b463ad.js"),
  s = require("polished/lib/helpers/rem"),
  f = require("../sectionContainer-2a921e1c.js");
function g(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
require("../_commonjsHelpers-f10b257f.js"), require("../extends-fa579b0f.js"), require("../objectWithoutProperties-2581b642.js"), require("../colors-c0f39aa2.js"), require("../link-8b1ebef7.js"), require("../scrollTo-90f777d5.js"), require("../globalStyles-0b32b53a.js"), require("polished/lib/helpers/em"), require("../breakpoints-359d04f5.js"), require("../gradients-74ddcb08.js"), require("polished/lib/color/shade"), require("../foundations/Icon/icons/utility/ArrowRight.js"), require("../getPrototypeOf-6e942d92.js"), require("../toPropertyKey-ec4a2a72.js"), require("../defineProperty-b53f90b9.js"), require("../foundations/Icon/icons/utility/ChevronLeftNarrow.js"), require("../foundations/Icon/icons/utility/ChevronRightNarrow.js"), require("../styles-df7980c2.js");
var p,
  m,
  h,
  b,
  y,
  v,
  T,
  w,
  k,
  q,
  j,
  L,
  S,
  E,
  C,
  _ = g(a),
  x = g(n),
  I = g(i),
  N = g(r),
  P = g(s);
var A = I["default"](l.Col)(p || (p = c._taggedTemplateLiteral(["\n  padding: 0 ", ";\n"])), P["default"](16)),
  R = I["default"](l.Col)(m || (m = c._taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  B = I["default"](l.Col)(h || (h = c._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.mediumUp();
    return i.css(b || (b = c._taggedTemplateLiteral(["\n      padding-bottom: ", ";\n    "])), t ? P["default"](40) : P["default"](24));
  }),
  O = I["default"].div(y || (y = c._taggedTemplateLiteral(["\n  && {\n    display: block;\n    width: ", ";\n    height: ", ";\n    margin-top: ", ";\n    text-align: center;\n    &::after {\n      display: none; /** hide stock Swiper arrow pagination */\n    }\n  }\n"])), P["default"](20), P["default"](16), P["default"](-16)),
  D = I["default"].div(v || (v = c._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.slideCount;
    return i.css(T || (T = c._taggedTemplateLiteral(["\n    position: relative;\n    bottom: ", ";\n    width: ", ";\n    height: ", ";\n    margin: 0 auto;\n    && { /** remove specificity after Video (Slider) and Content Hub (Slider) get refactored to utilize Slider Component, and the removal of carousel.scss */\n      .swiper-button-prev {\n        margin-left: ", "; /** offset pagination left button, also overwrites any Swiper css style stragglers */\n      }\n    }\n  "])), P["default"](-32), P["default"](40 * t), P["default"](16), P["default"](-10));
  }),
  V = I["default"].div(w || (w = c._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.themeType,
      n = "darkTheme" === a ? t.colors.action.darkTheme.linkDefault : t.colors.action.lightTheme.linkDefault;
    return i.css(k || (k = c._taggedTemplateLiteral(["\n    height: ", ";\n    .swiper-pagination-bullet {\n      background-color: ", ";\n      opacity: 1;\n      :hover {\n        background-color: ", ";\n      }\n      &-active {\n        background-color: ", ";\n        :hover {\n          background-color: ", ";\n        }\n      }\n    }\n  "])), P["default"](16), t.colors.neutral.grayLight10, n, n, "darkTheme" === a ? t.colors.action.darkTheme.linkHover : t.colors.action.lightTheme.linkHover);
  }),
  H = I["default"].div(q || (q = c._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.smallUp();
    return i.css(j || (j = c._taggedTemplateLiteral(["\n      display: flex;\n      width: 100%;\n      padding: ", ";\n      justify-content: center;\n    "])), "0 ".concat(t ? P["default"](16) : P["default"](20)));
  }),
  z = I["default"](l.Row)(L || (L = c._taggedTemplateLiteral(["\n  width: 100%;\n  justify-content: center;\n"]))),
  M = I["default"](l.Row)(S || (S = c._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return i.css(E || (E = c._taggedTemplateLiteral(["\n    && {\n      width: 100%;\n      height: 100%;\n      padding-bottom: ", ";\n    }\n    .swiper-pagination {\n      &-bullet {\n        margin: 0 ", ";\n        background-color: ", ";\n        opacity: 1;\n\n        &-active {\n          background-color:", "\n        }\n      }\n    }\n  "])), P["default"](32), P["default"](10), t.colors.neutral.gray, t.colors.action.lightTheme.linkDefault);
  }),
  U = I["default"](f.SectionContainerComponent)(C || (C = c._taggedTemplateLiteral(["\n  padding-bottom: ", ";\n"])), P["default"](28)),
  W = function W() {
    return "undefined" != typeof document && function (e, a, n) {
      var i = n;
      setTimeout(function () {
        for (var n = e, r = 0; r < n.length; r += 1) a.push(n[r].offsetHeight);
        for (var l = 0; l < a.length; l += 1) i = Math.max.apply(Math, t._toConsumableArray(a)), n[l].style.height = "".concat(i, "px");
      }, 100);
    }(document.querySelectorAll(".js-dynamic-callout-card-content-container"), [], undefined), !1;
  },
  F = function F(t) {
    var n = t.backgroundVariant,
      r = t.branding,
      c = t.className,
      s = t.config,
      f = t.contentHubItems,
      g = t.disableBottomPadding,
      p = t.disableLazyLoad,
      m = t.disableSwiperScripts,
      h = t.headingText,
      b = t.isOutgoingLink,
      y = t.sectionId,
      v = t.subText,
      T = t.themeType,
      w = a.useContext(i.ThemeContext).mediumUp(),
      k = a.useState(w),
      q = e._slicedToArray(k, 2),
      j = q[0],
      L = q[1],
      S = a.useState(!1),
      E = e._slicedToArray(S, 2),
      C = E[0],
      I = E[1],
      N = a.useRef(),
      P = f.reduce(function (e, t) {
        var a = (t || {}).entity || {},
          i = a.title || "",
          l = a.fieldSubtype || "",
          d = (a.path || {}).alias || "";
        d = function (e) {
          var t = e.replace(/(^\/+)/g, "");
          return t.includes("?") && t.includes("=") || t.endsWith("/") ? t : "".concat(t, "/");
        }(d);
        var u = function (e, t) {
            var a = e || t.entityBundle || "";
            return "pillar_page" === a ? a = "guide" : "article_2" === a && (a = "article"), a;
          }(l, a),
          c = function (e) {
            var t, a, n;
            return t = "article_2" === e.entityBundle ? null !== (a = e.fieldFeaturedImage.entity) && void 0 !== a && null !== (n = a.fieldMediaImage2) && void 0 !== n && n.entity.uri.value ? e.fieldFeaturedImage.entity.fieldMediaImage2.entity.uri.value : e.fieldFeaturedImage.entity.fieldImageAsset.entity.fieldMediaImage.entity.uri.value : e.fieldImage.entity.fieldImageAsset.entity.fieldMediaImage.entity.uri.value, t || "";
          }(a),
          f = function (e) {
            var t = "Learn more";
            return "podcast" === e ? t = "Listen now" : "quiz" === e ? t = "Take the quiz" : "guide" === e ? t = "Read the guide" : "calculator" === e ? t = "Calculate it" : "video" === e && (t = "Watch now"), t;
          }(u),
          g = function (e, t) {
            var a = "";
            return "article" !== e && "article_2" !== e && "pillar_page" !== e || (t.fieldDatePublished || {}).value && (a = new Date(((t.fieldDatePublished || {}).value || "").replace(/-/g, "/")).toLocaleString("en-US", {
              month: "long",
              day: "2-digit",
              year: "numeric"
            })), a;
          }(u, a),
          m = function (e, t) {
            if (!e) return "";
            var a = e.includes(".") ? e.lastIndexOf(".") : e.length,
              n = e.substr(0, a);
            return "".concat(n, ".").concat(t);
          }(c, "webp"),
          h = "lightA";
        return "lightA" === n && (h = "lightB"), i && u && d && c && e.push(_["default"].createElement(o.DynamicCallout, {
          actionId: c.replace("s3://", "").split(".")[0],
          backgroundVariant: h,
          branding: r,
          disableLazyLoad: p,
          flag: "pcg" === r ? "pcg" : "secondary",
          image: "".concat(s.mediaBasePath, "/images/640x480/").concat(c.replace("s3://", "")),
          imageWebp: "".concat(s.mediaBasePath, "/images/640x480/").concat(m.replace("s3://", "")),
          isOutgoingLink: b,
          metadata: g,
          orientation: "card",
          tag: u.replace("_", " "),
          themeType: T,
          title: i,
          url: "".concat(s.basePath).concat("calculator" === u ? "" : "/life-and-money", "/").concat(d),
          visualLink: f
        })), e;
      }, []),
      F = a.useCallback(function () {
        W();
      }, []);
    a.useEffect(function () {
      L(w);
    }, [w]), a.useEffect(function () {
      m || u.appendSwiperScripts(I);
    }, []), a.useEffect(function () {
      C && "undefined" != typeof Swiper && new Swiper(".swiper-container", {
        slidesPerView: 1,
        centeredSlides: !0,
        grabCursor: !0,
        speed: 400,
        loop: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: !0,
          type: "bullets"
        }
      });
    }, [C, j]);
    return _["default"].createElement(U, {
      id: y,
      className: x["default"]("nmx-no-print", c),
      backgroundVariant: n,
      disableBottomPadding: g,
      ref: N,
      moduleName: "content-hub-module",
      moduleVariation: "A",
      themeType: T
    }, _["default"].createElement(l.Row, {
      align: "center"
    }, _["default"].createElement(l.Col, {
      medium: 8
    }, _["default"].createElement(d.TypographyComponent, {
      component: "h2",
      branding: r,
      themeType: T,
      nextElement: v ? "typography" : "graphic",
      align: "center"
    }, h)), v && _["default"].createElement(B, null, _["default"].createElement(d.TypographyComponent, {
      themeType: T,
      disableBottomPadding: !0
    }, v)), j ? _["default"].createElement(R, null, _["default"].createElement("div", {
      ref: F
    }, _["default"].createElement(l.Row, {
      align: "left"
    }, P.map(function (e, t) {
      return _["default"].createElement(A, {
        small: 6,
        large: 4,
        key: "desktop-content-hub-card-".concat(t + 1)
      }, e);
    })))) : _["default"].createElement(M, {
      className: "swiper-container"
    }, _["default"].createElement(R, {
      className: "nmx-section-thisSwiperCarousel-items swiper-wrapper"
    }, P.map(function (e, t) {
      return _["default"].createElement(H, {
        className: "swiper-slide",
        key: "desktop-content-hub-mobile-swiper-".concat(t + 1)
      }, _["default"].createElement(z, null, _["default"].createElement(R, {
        small: 10,
        className: "nmx-align-center"
      }, e)));
    })), _["default"].createElement(D, {
      className: "nmx-slider-navigation",
      slideCount: P.length
    }, _["default"].createElement(V, {
      className: "swiper-pagination",
      themeType: T
    }), _["default"].createElement(O, {
      className: "swiper-button-prev"
    }, _["default"].createElement(u.IconStyledLeftSliderSwiperNavigation, {
      $themeType: T
    })), _["default"].createElement(O, {
      className: "swiper-button-next"
    }, _["default"].createElement(u.IconStyledRightSliderSwiperNavigation, {
      $themeType: T
    }))))));
  };
F.propTypes = {
  backgroundVariant: N["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: N["default"].oneOf(["nm", "pcg"]),
  config: N["default"].any,
  contentHubItems: N["default"].any.isRequired,
  className: N["default"].string,
  disableBottomPadding: N["default"].bool,
  disableLazyLoad: N["default"].bool,
  disableSwiperScripts: N["default"].bool,
  headingText: N["default"].oneOfType([N["default"].string, N["default"].object]).isRequired,
  isOutgoingLink: N["default"].bool,
  sectionId: N["default"].string.isRequired,
  subText: N["default"].oneOfType([N["default"].string, N["default"].object]),
  themeType: N["default"].oneOf(["lightTheme", "darkTheme"])
}, F.defaultProps = {
  backgroundVariant: "lightC",
  branding: "nm",
  disableBottomPadding: !1,
  disableSwiperScripts: !1,
  themeType: "lightTheme"
}, module.exports = F;